"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setInitialAddressOfProductValues = exports.default = void 0;
var _core = require("@material-ui/core");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _reactRedux = require("react-redux");
var _config = require("../config");
var _LocationPicker = _interopRequireDefault(require("../components/LocationPicker"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var setInitialAddressOfProductValues = function setInitialAddressOfProductValues(product, addressOfStore) {
  if (_config.USE_ADDRESS_OF_STORE_IN_PRODUCT_CREATION && !_lodash.default.isEmpty(addressOfStore)) {
    return {
      "address-address_01": _lodash.default.get(product, "address.address_01", addressOfStore.address_01),
      "address-city": _lodash.default.get(product, "address.city", addressOfStore.city),
      "address-country": _lodash.default.get(product, "address.country", addressOfStore.country),
      "address-country_code": _lodash.default.get(product, "address.country_code", addressOfStore.country_code),
      "address-latitude": _lodash.default.get(product, "address.latitude", addressOfStore.latitude),
      "address-longitude": _lodash.default.get(product, "address.longitude", addressOfStore.longitude)
    };
  }
  return {
    "address-address_01": _lodash.default.get(product, "address.address_01", ""),
    "address-city": _lodash.default.get(product, "address.city", ""),
    "address-country": _lodash.default.get(product, "address.country", ""),
    "address-country_code": _lodash.default.get(product, "address.country_code", ""),
    "address-latitude": _lodash.default.get(product, "address.latitude", undefined),
    "address-longitude": _lodash.default.get(product, "address.longitude", undefined)
  };
};
exports.setInitialAddressOfProductValues = setInitialAddressOfProductValues;
var AddressOfProductFields = /*#__PURE__*/function (_React$Component) {
  _inherits(AddressOfProductFields, _React$Component);
  var _super = _createSuper(AddressOfProductFields);
  function AddressOfProductFields() {
    _classCallCheck(this, AddressOfProductFields);
    return _super.apply(this, arguments);
  }
  _createClass(AddressOfProductFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!Boolean(_config.USE_GOOGLE_PLACES_FOR_ADDRESS)) {
        var _this$props = this.props,
          countries = _this$props.countries,
          dispatch = _this$props.dispatch,
          values = _this$props.values;
        if (countries && _lodash.default.isEmpty(countries)) {
          dispatch({
            type: 'FETCH_COUNTRIES'
          });
        }
        if (values['address-country']) {
          dispatch({
            type: 'FETCH_STATES',
            params: {
              'country.id': values['address-country']
            }
          });
        }
        if (values['address-state']) {
          dispatch({
            type: 'FETCH_CITIES',
            params: {
              'state.id': values['address-state']
            }
          });
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // check if the country is changed and load states of country
      if (!Boolean(_config.USE_GOOGLE_PLACES_FOR_ADDRESS)) {
        if (_lodash.default.get(this.props, 'values.address-country') !== _lodash.default.get(nextProps, 'values.address-country')) {
          // remove the values of all fields related to a country
          this.props.setFieldValue('address-state', undefined);
          this.props.setFieldValue('address-city', undefined);
          this.props.setFieldValue('address-address_01', '');
          this.props.dispatch({
            type: 'CLEAN_CITIES'
          });
          this.props.dispatch({
            type: 'CLEAN_STATES'
          });
          // get the states of selected country
          this.props.dispatch({
            type: 'FETCH_STATES',
            params: {
              'country.id': nextProps.values['address-country']
            }
          });
        }
        // check if the state is changed and load cities of state
        if (_lodash.default.get(nextProps, 'values.address-state') && _lodash.default.get(this.props, 'values.address-state') !== _lodash.default.get(nextProps, 'values.address-state')) {
          // remove values of all fields related to a state
          this.props.setFieldValue('address-city', undefined);
          this.props.setFieldValue('address-address_01', '');
          this.props.dispatch({
            type: 'CLEAN_CITIES'
          });
          // get the cities of selelcted state
          this.props.dispatch({
            type: 'FETCH_CITIES',
            params: {
              'state.id': nextProps.values['address-state']
            }
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        countries = _this$props2.countries,
        states = _this$props2.states,
        cities = _this$props2.cities;
      var useGoogle = Boolean(_config.USE_GOOGLE_PLACES_FOR_ADDRESS);
      var useMap = Boolean(_config.USE_MAP_IN_PRODUCT_CREATION);
      var unusedFields = this.props.unusedFields || [];
      return /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        spacing: 2
      }, useGoogle && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_formFields.AddressAutocomplete, {
        fullWidth: true,
        required: true,
        label: "Address",
        name: "address-address_01",
        validate: (0, _formValidators.required)(this.props.initialErrors['address-address_01']),
        updateAfterTyping: true,
        isForced: this.props.isForced
      })), !_lodash.default.includes(unusedFields, 'country') && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12,
        md: unusedFields.length === 0 ? 4 : unusedFields.length === 1 ? 6 : 12
      }, !useGoogle ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
        variant: "outlined",
        fullWidth: true,
        required: true,
        label: "Pays",
        name: "address-country",
        margin: "normal",
        validate: (0, _formValidators.required)()
      }, countries && countries.map(function (country) {
        return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
          key: country.id,
          value: country.id
        }, country.name);
      })) : /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
        variant: "outlined",
        name: "address-country",
        label: "Pays",
        type: "text",
        margin: "normal",
        fullWidth: true,
        multiline: true,
        validate: (0, _formValidators.required)(),
        required: true
      })), !_lodash.default.includes(unusedFields, 'state') && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12,
        md: unusedFields.length === 0 ? 4 : unusedFields.length === 1 ? 6 : 12
      }, !useGoogle ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
        variant: "outlined",
        fullWidth: true,
        required: true,
        label: "D\xE9partement",
        name: "address-state",
        margin: "normal",
        validate: (0, _formValidators.required)()
      }, states && states.map(function (state) {
        return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
          key: state.id,
          value: state.id
        }, state.name);
      })) : /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
        variant: "outlined",
        name: "address-state",
        label: "D\xE9partement",
        type: "text",
        margin: "normal",
        fullWidth: true,
        multiline: true,
        validate: (0, _formValidators.required)(),
        required: true
      })), !_lodash.default.includes(unusedFields, 'city') && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12,
        md: unusedFields.length === 0 ? 4 : unusedFields.length === 1 ? 6 : 12
      }, !useGoogle ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
        variant: "outlined",
        fullWidth: true,
        required: true,
        label: "Commune",
        name: "address-city",
        margin: "normal",
        validate: (0, _formValidators.required)()
      }, cities && cities.map(function (city) {
        return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
          key: city.id,
          value: city.id
        }, city.name);
      })) : /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
        variant: "outlined",
        name: "address-city",
        label: "Commune",
        type: "text",
        margin: "normal",
        fullWidth: true,
        multiline: true,
        validate: (0, _formValidators.required)(),
        required: true
      })), !useGoogle && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
        name: "address-address_01",
        label: "Address",
        type: "text",
        margin: "normal",
        fullWidth: true,
        multiline: true,
        rows: "3",
        validate: (0, _formValidators.required)(),
        required: true
      })), useMap && useGoogle && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_LocationPicker.default, _extends({
        defaultLatLng: {
          lat: 45.73289289497116,
          lng: 3.0993164062499545
        }
      }, this.props))));
    }
  }]);
  return AddressOfProductFields;
}(_react.default.Component);
var _default = (0, _reactRedux.connect)(function (_ref) {
  var addressReducer = _ref.addressReducer;
  return _objectSpread({}, _lodash.default.pick(addressReducer, ['countries', 'states', 'cities']));
})(AddressOfProductFields);
exports.default = _default;